import { Component, Input } from '@angular/core';

/**
 * `<app-submission-topics-display>` — apresentação READ-ONLY da linha
 * "Tópicos: A, B, C." de uma submissão. Extraído do `paper-info` como
 * primeiro passo do refactor pra `<app-submission-export-view>`.
 *
 * Zero dependências (só o pipe `translate`), zero HTTP, zero forms —
 * é apresentação pura por Input. Usado tanto no paper-info (modo
 * read-only, edit permanece inline lá) quanto no fluxo de download
 * HTML (via `<app-submission-export-view>`).
 */
@Component({
  selector: 'app-submission-topics-display',
  templateUrl: './submission-topics-display.component.html',
  styleUrls: ['./submission-topics-display.component.scss'],
})
export class SubmissionTopicsDisplayComponent {
  /** Lista de tópicos (com `name`) — se vazia/undefined o componente não
   *  renderiza nada (equivalente ao `*ngIf="submission.topics?.length"` do
   *  wrapper antigo). */
  @Input() topics: Array<{ name: string }> | null | undefined;
}
